import { EmployeeOrder } from '../types/employee.types'

export default function getMinPrioritySubCategory(employeeOrder?: EmployeeOrder[]): {
  priorityOfSubcategory: number
  priorityWithinSubCategory: number
} {
  let priorityOfSubcategory = Infinity
  let priorityWithinSubCategory = Infinity

  if (!employeeOrder) {
    return { priorityOfSubcategory, priorityWithinSubCategory }
  }
  // eslint-disable-next-line no-restricted-syntax, fp/no-loops
  for (const order of employeeOrder) {
    const currPriorityOfSubCategory = Number(order.orderOfSubCategory) || Infinity
    if (currPriorityOfSubCategory < priorityOfSubcategory) {
      priorityOfSubcategory = currPriorityOfSubCategory
      const currPriorityWithinSubCategory = Number(order.employeeOrderInSubCategory) || Infinity
      priorityWithinSubCategory = currPriorityWithinSubCategory
    }
  }

  return { priorityOfSubcategory, priorityWithinSubCategory }
}
